/**
 * MobileHub — стартовый экран мобильного приложения, 1-в-1 повтор Android
 * HubScreen.kt: TopAppBar «SWIPA» (bold 20sp, Surface900) + сетка сервисов
 * 2 колонки (padding/spacing 16dp), карточки 1:1 (radius 20dp, Surface800,
 * elevation 4dp, иконка 96dp radius 16dp, подпись 16sp SemiBold Surface200).
 * Сервисы и иконки — те же ассеты, что в Android (ic_service_*).
 * «Новости» в Android — заглушка (onServiceClick TODO) → здесь тоже no-op.
 */
const services = [
  { id: 'chat', title: 'Чат', icon: '/ic_service_chat.png', enabled: true },
  { id: 'miniapps', title: 'Мини-аппы', icon: '/ic_service_miniapps.svg', enabled: true },
  { id: 'news', title: 'Новости', icon: '/ic_service_news.png', enabled: true, noop: true },
] as const;

export default function MobileHub({ onService }: { onService: (id: string) => void }) {
  return (
    <div className="flex flex-col h-full w-full bg-surface-950">
      {/* TopAppBar: только заголовок, без экшенов (как HubScreen) */}
      <div className="an-topbar">
        <span className="an-topbar__title an-topbar__title--plain">SWIPA</span>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="an-hub-grid">
          {services.map((s) => (
            <button
              key={s.id}
              className="an-hub-card"
              onClick={() => {
                if ('noop' in s && s.noop) return; // news: TODO как в Android
                onService(s.id);
              }}
            >
              <img src={s.icon} alt={s.title} className="an-hub-card__icon" draggable={false} />
              <span className="an-hub-card__title">{s.title}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
